export default __webpack_public_path__ + "static/media/po-financing.f1037165.png";